<script>
export default {
  name: 'PageFooter',
  // The year is calculated directly in the template.
  // Assumes $t for i18n is globally available or injected.
  // Assumes BootstrapVue components (BContainer, BRow, BCol, BLink) are globally registered or available.
}
</script>

<template>
  <footer class="custom-footer bg-dark py-5 position-relative">
    <BContainer>
      <BRow>
        <BCol lg="4" class="mt-4">
          <div>
            <div>
              <!-- Ensure the image path is correct and $t works as expected -->
              <img src="@/assets/images/ml/ml_logo_imageonly.png" :alt="$t('landing.alt.logoLight')" height="50">
            </div>
            <div class="mt-4 fs-13">
              <p>{{ $t('landing.footer.description') }}</p>
            </div>
          </div>
        </BCol>

        <BCol lg="7" class="ms-lg-auto">
          <BRow>
            <BCol sm="4" class="mt-4">
              <h5 class="text-white mb-0">MysticLog</h5>
              <div class="text-muted mt-3">
                <ul class="list-unstyled ff-secondary footer-list fs-14">
                  <li>
                    <BLink to="/#home">{{ $t('landing.navbar.home') }}</BLink>
                  </li>
                  <li>
                    <BLink to="/#features">{{ $t('landing.navbar.features') }}</BLink>
                  </li>
                  <li>
                    <BLink to="/#plans">{{ $t('landing.navbar.plans') }}</BLink>
                  </li>
                  <li>
                    <BLink to="/#contact">{{ $t('landing.footer.faqs') }}</BLink>
                  </li>
                  <li>
                    <BLink to="/privacy">{{ $t('landing.footer.privacyPolicy') }}</BLink>
                  </li>
                  <li>
                    <BLink to="/terms">{{ $t('landing.footer.termsAndConditions') }}</BLink>
                  </li>
                </ul>
              </div>
            </BCol>
            <BCol sm="4" class="mt-4">
              <!-- Optional: Add another column if needed -->
            </BCol>
          </BRow>
        </BCol>
      </BRow>

      <BRow class="text-center text-sm-start align-items-center mt-5">
        <BCol sm="6">
          <div>
            <p class="copy-rights mb-0">
              {{ new Date().getFullYear() }} {{ $t('landing.footer.copyright') }}
            </p>
          </div>
        </BCol>
        <BCol sm="6">
          <div class="text-sm-end mt-3 mt-sm-0">
            <ul class="list-inline mb-0 footer-social-link">
              <li class="list-inline-item">
                <a href="https://www.facebook.com/profile.php?id=61573436312178" class="avatar-xs d-block" target="_blank" rel="noopener noreferrer">
                  <div class="avatar-title rounded-circle">
                    <i class="ri-facebook-fill"></i>
                  </div>
                </a>
              </li>
<!--               <li class="list-inline-item">
                <router-link to="javascript: void(0);" class="avatar-xs d-block">
                  <div class="avatar-title rounded-circle">
                    <i class="ri-youtube-fill"></i>
                  </div>
                </router-link>
              </li> -->
              <li class="list-inline-item">
                <a href="https://www.instagram.com/mysticlog.app/" class="avatar-xs d-block" target="_blank" rel="noopener noreferrer">
                  <div class="avatar-title rounded-circle">
                    <i class="ri-instagram-fill"></i>
                  </div>
                </a>
              </li>
            </ul>
          </div>
        </BCol>
      </BRow>
    </BContainer>
  </footer>
</template>

<style scoped>
/* Basic styling to ensure readability on a dark background if not globally defined */
.custom-footer {
  color: #adb5bd; /* Light grey text for dark backgrounds */
}
.custom-footer h5, .custom-footer .text-white {
  color: #ffffff !important; /* Ensure white text for headings */
}
.custom-footer .text-muted ul.footer-list li a {
  color: #adb5bd; /* Link color */
}
.custom-footer .text-muted ul.footer-list li a:hover {
  color: #ffffff; /* Link hover color */
}
.copy-rights {
  color: #adb5bd;
}
.footer-social-link .list-inline-item a .avatar-title {
  background-color: rgba(255, 255, 255, 0.1); /* Subtle background for social icons */
  color: #ffffff;
}
.footer-social-link .list-inline-item a:hover .avatar-title {
  background-color: rgba(255, 255, 255, 0.2);
}
/* If ff-secondary is a custom font class, ensure its definition is globally available or add it here */
/* .ff-secondary { font-family: 'YourSecondaryFont', sans-serif; } */
</style>